import React from 'react';
import { useTranslation } from 'react-i18next';

const Termos = () => {
    const { t } = useTranslation('terms'); // Usando o namespace 'terms'

    return (
        <>
            <h2 className="terms-title container">{t('title')}</h2>
            <section id="terms" className="terms-section container">
                <div className="terms-container">
                    <p>{t('intro')}</p>

                    <h3>{t('sections.use.title')}</h3>
                    <p>{t('sections.use.text')}</p>
                    
                    <h3>{t('sections.privacy.title')}</h3>
                    <p>{t('sections.privacy.text')}</p>
                    
                    <h3>{t('sections.copyright.title')}</h3>
                    <p>{t('sections.copyright.text')}</p>
                    
                    <h3>{t('sections.changes.title')}</h3>
                    <p>{t('sections.changes.text')}</p>
                </div>
            </section>

            <br/>

            <h2 className="terms-title container">{t('policy.title')}</h2>
            <section id="policy" className="terms-section container">
                <div className="terms-container">
                    <h3>{t('policy.data.title')}</h3>
                    <p>{t('policy.data.text')}</p>
                    
                    <h3>{t('policy.usage.title')}</h3>
                    <p>{t('policy.usage.text')}</p>
                    
                    <h3>{t('policy.protection.title')}</h3>
                    <p>{t('policy.protection.text')}</p>
                    
                    <h3>{t('policy.share.title')}</h3>
                    <p>{t('policy.share.text')}</p>

                    <h3>{t('policy.editing.title')}</h3>
                    <p>{t('policy.editing.text')}</p>
                </div>
            </section>

            <br/>

            <h2 className="terms-title container">{t('cookies.title')}</h2>
            <section id="cookies" className="terms-section container">
                <div className="terms-container">

                    <h3>{t('cookies.usage.title')}</h3>
                    <p>{t('cookies.usage.text')}</p>

                    <p>{t('cookies.usage.text_secondary')}</p>
                </div>
            </section>

            <br/>
        </>
    );
};

export default Termos;
